<template>
  <svg xmlns="http://www.w3.org/2000/svg" width="38" height="30" viewBox="0 0 38 30">
    <g fill="none" fill-rule="evenodd" stroke-linecap="round" stroke-linejoin="round">
      <g stroke="#5CD18A" stroke-width="4">
        <g>
          <g>
            <path d="M2 16.612L12.356 28 36 2" transform="translate(-701 -185) translate(670 150) translate(31 35)" />
          </g>
        </g>
      </g>
    </g>
  </svg>
</template>